export default {
  // Navbar
  features: "Features",
  solutions: "Solutions",
  testimonials: "Testimonials",
  pricing: "Pricing",
  getStarted: "Get Started",
  signIn: "Sign In",
  signUp: "Sign Up",
  darkMode: "Dark Mode",
  lightMode: "Light Mode",

  // Hero
  newVersion: "New Version 2.0 is Live",
  heroTitle: "Manage Tasks with",
  heroSubtitle: "Absolute Clarity",
  heroDescription:
    "Brooklyn Task empowers teams to organize, prioritize, and track work significantly faster. Stop drowning in chaos and start delivering results.",
  startForFree: "Start for Free",
  watchDemo: "Watch Demo",
  trustedBy: "Trusted by innovative teams at",

  // Problems
  problemsTitle: "Why is work so chaotic?",
  problemsSubtitle:
    "You're hiring great people, but the process is broken. The result? Missed deadlines, burnout, and confusion.",
  problem1Title: "Communication Silos",
  problem1Desc:
    'Updates are scattered across email, Slack, and spreadsheets. No one knows where to look for the "latest" version.',
  problem2Title: "Missed Deadlines",
  problem2Desc:
    "Without clear visibility, critical tasks slip through the cracks. Projects get delayed, and clients get unhappy.",
  problem3Title: "Zero Visibility",
  problem3Desc:
    'Managers spend hours just trying to figure out "who is doing what" instead of actually managing strategy.',

  // Solutions
  solution1Badge: "Task Management",
  solution1Title: "Routine & One-Time Tasks",
  solution1Desc:
    'Distinguish between recurring operational work and specific project milestones. Brooklyn Task organizes your "Routine Tasks" separately from "One-Time Tasks" for maximum clarity.',
  solution1Feature1: "Dedicated Routine Task workflows",
  solution1Feature2: "One-Time Project Milestones",
  solution1Feature3: "Advanced filtering by Department",

  solution2Badge: "Team & Goals",
  solution2Title: "Align Teams with Company Goals.",
  solution2Desc:
    "Don't just track tasks—track impact. Connect individual work directly to high-level company Goals and Department KPIs.",
  solution2Feature1: "Visual Goal Tracking",
  solution2Feature2: "Department-level Performance Reports",
  solution2Feature3: "Automated Progress Trends",

  // Features
  featuresTitle: "Everything you need to ship faster",
  featuresSubtitle:
    "Powerful features wrapped in a simple, intuitive interface.",
  feature1Title: "Routine Tasks",
  feature1Desc: "Streamline recurring daily operations.",
  feature2Title: "Goal Tracking",
  feature2Desc: "Connect tasks to company objectives.",
  feature3Title: "Departments",
  feature3Desc: "Organize workforce by specific units.",
  feature4Title: "Work Force",
  feature4Desc: "Manage agreements and employee data.",
  feature5Title: "Automations",
  feature5Desc: "Trigger actions on task updates.",
  feature6Title: "Reports & Insights",
  feature6Desc: "Visual charts for performance trends.",
  feature7Title: "Multilingual",
  feature7Desc: "Full support for English and Arabic.",
  feature8Title: "Integrations",
  feature8Desc: "Connects with your favorite apps.",

  // How It Works
  howItWorksTitle: "Get started in 3 steps",
  howItWorksSubtitle: "No credit card required. Up and running in minutes.",
  step1Title: "Create Workspace",
  step1Desc:
    "Sign up and invite your team members. Organize by department or project.",
  step2Title: "Import or Create",
  step2Desc:
    "Import tasks from Trello/Asana or start fresh with our templates.",
  step3Title: "Start Working",
  step3Desc: "Assign tasks, track progress, and celebrate wins with the team.",

  // Testimonials
  testimonialsTitle: "Loved by 10,000+ teams",
  testimonial1Text:
    "Brooklyn Task completely transformed how our engineering team operates. We ship 2x faster now.",
  testimonial1Name: "Sarah Jenkins",
  testimonial1Role: "CTO at TechFlow",
  testimonial2Text:
    "The best UI I've seen in a task manager. It's actually fun to use, which is rare for enterprise software.",
  testimonial2Name: "Michael Chen",
  testimonial2Role: "Product Manager",
  testimonial3Text:
    "Finally, a tool that makes sense for both creative and technical teams. Highly recommended.",
  testimonial3Name: "Jessica Alverez",
  testimonial3Role: "Design Director",

  // Pricing
  pricingTitle: "Simple, transparent pricing",
  pricingSubtitle: "Choose the perfect plan for your team",
  choosePlan: "Choose Plan",
  tryForFree: "Try for Free",
  perMonth: "/month",
  noPlansAvailable: "No plans available at the moment",

  // CTA
  ctaTitle: "Ready to regain control?",
  ctaDescription:
    "Join thousands of companies using Brooklyn Task to deliver projects on time, every time.",
  getStartedForFree: "Get Started for Free",
  scheduleDemo: "Schedule Demo",
  ctaFooter: "No credit card required • 14-day free trial",

  // Footer
  footerDescription:
    "The all-in-one workspace for your tasks, notes, and projects. simple, flexible, and powerful.",
  footerProduct: "Product",
  footerCompany: "Company",
  footerLegal: "Legal",
  integrations: "Integrations",
  changelog: "Changelog",
  aboutUs: "About Us",
  careers: "Careers",
  blog: "Blog",
  contact: "Contact",
  privacyPolicy: "Privacy Policy",
  termsOfService: "Terms of Service",
  security: "Security",
  footerCopyright: "© 2026 Brooklyn. All rights reserved.",
};
